/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeEventHandler, KeyboardEventHandler } from 'react';
import type { FieldPath, FieldValues } from 'react-hook-form';

export enum FiltersStates {
	All = 'Todos los estados',
	Disabled = 'Inactivos',
	Enabled = 'Activos',
}

interface InputCommonOptions<Form extends FieldValues, D> {
	control: any;
	defaultValue?: D;
	name: FieldPath<Form>;
	placeholder?: string;
	startAdorment?: React.ReactElement;
	width?: string | number;
	disabled?: boolean;
}

export interface InputTextOptions<Form extends FieldValues, D> extends InputCommonOptions<Form, D> {
	onChange?(onChange: (...event: any[]) => void): ChangeEventHandler<HTMLInputElement>;
	onClear?(): void;
	onKeyPress?: KeyboardEventHandler<HTMLInputElement>;
}

interface InputSelectOption<D> {
	label: string;
	value: D;
}

export interface InputSelectOptions<Form extends FieldValues, D>
	extends InputCommonOptions<Form, D> {
	options: InputSelectOption<D>[];
}

export type InputOptions<Form extends FieldValues> =
	| InputSelectOptions<Form, any>
	| InputTextOptions<Form, any>;
